import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Error from './img/error@2x.png';
import Success from './img/verified@2x.png';
import { Overlay } from './../UIComponents';
import './Modal.scss';

export default function VerifingStatusModal({ visibility, status, onClose }) {
  const onContentClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div className={classnames('modal', { open: visibility })} >
      <Overlay onOverlayClick={onClose}>
        <a href="" className="verifying-status" onClick={onContentClick}>
          {
            status ?
              <img src={Success} alt="presentation" width="55" /> :
              <img src={Error} alt="presentation" width="55" />
          }
          {
            status ?
              <h4>Saved</h4> :
              <h4>Oops! There was some error, please try again later</h4>
          }
        </a>
      </Overlay>
    </div>
  );
}

VerifingStatusModal.defaultProps = {
  onClose: () => {},
  visibility: false,
  status: false,
};

VerifingStatusModal.propTypes = {
  onClose: PropTypes.func,
  visibility: PropTypes.bool,
  status: PropTypes.bool,
};
